import React from 'react';

const SankeyFlowTooltip = ({ active, payload }) => {
  if (!active || !payload?.length) return null;

  const item = payload[0];
  const name = item?.name ?? item?.payload?.name ?? 'Flow';
  const value = Number(item?.value ?? item?.payload?.value ?? 0);

  return (
    <div className="rounded-md px-3 py-2 border border-hairline bg-bone-raised">
      <p className="text-body font-medium text-ink mb-0.5">{name}</p>
      <p className="figure text-h3 text-pine">
        ${value.toLocaleString('en-US', { maximumFractionDigits: 0 })}
      </p>
      <p className="text-label text-ink-muted mt-1">Monthly amount in this flow</p>
    </div>
  );
};

export default SankeyFlowTooltip;
